import React from "react";

export default function WhyChooseUs() {
    const reasons = [
        {
            icon: "fa-solid fa-rocket", // Ikon teknologi
            title: "Teknologi Terkini",
            description:
                "Menggunakan peralatan dan solusi mutakhir yang sesuai dengan perkembangan teknologi terbaru.",
        },
        {
            icon: "fa-solid fa-bullseye", // Ikon pendekatan kustom
            title: "Solusi yang Disesuaikan",
            description:
                "Setiap solusi yang kami tawarkan disesuaikan dengan kebutuhan dan anggaran klien, memberikan hasil yang optimal.",
        },
        {
            icon: "fa-solid fa-cube", // Ikon desain 3D
            title: "Desain 3D yang Memudahkan Keputusan",
            description:
                "Klien dapat melihat dan merasakan visualisasi ruang yang akan diterapkan, memastikan keputusan yang lebih tepat.",
        },
        {
            icon: "fa-solid fa-users", // Ikon tim profesional
            title: "Pengalaman dan Profesionalisme",
            description:
                "Tim kami terdiri dari profesional berpengalaman di masing-masing bidangnya yang siap memberikan solusi terbaik dan layanan purna jual yang dipercaya.",
        },
    ];

    return (
        <section id="why-choose-us" className="why-choose-us-section section">
            <div className="container">
                <h2 className="section-title">Mengapa Memilih Kami?</h2>
                <div className="row">
                    {reasons.map((reason, index) => (
                        <div key={index} className="col-md-3 col-sm-6 why-card">
                            <div className="icon-box">
                                <i className={reason.icon}></i>
                            </div>
                            <h3>{reason.title}</h3>
                            <p>{reason.description}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}